import { sqliteTable, text } from "drizzle-orm/sqlite-core";
import { timestamps } from "../utils/fields";

export const offlineAccessLeases = sqliteTable("offline_access_leases", {
  ...timestamps,
  userId: text("user_id").primaryKey(),
  validatedAtServer: text("validated_at_server").notNull(),
  validUntilServer: text("valid_until_server"),
  receivedAtDevice: text("received_at_device").notNull(),
  maxObservedAtDevice: text("max_observed_at_device").notNull(),
  invalidatedAtDevice: text("invalidated_at_device"),
  invalidationReason: text("invalidation_reason", {
    enum: ["server_invalid", "expired", "clock_rollback"],
  }),
});

export type OfflineAccessLease = typeof offlineAccessLeases.$inferSelect;
